import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { SiteConfigManager, usePreferences } from '@atlas/core';
import { ViewportDisplayController } from '@atlas/ui';

import MarketTypeSelector from 'common/MarketTypeSelector/MarketTypeSelector';
import categoryShape from 'common/PropTypes/categoryShape';
import SeoPageText from 'components/SeoPage/SeoPageText';

import ExpandableCategoryTournaments from './ExpandableCategoryTournaments';

const CategoryPlaceholder = React.forwardRef((props, ref) => {
  const { counter = 0 } = props;

  const style = {
    height: `${counter * 160 + 48}px`,
  };

  return <div className="category placeholder" ref={ref} style={style} />;
});

const CategoriesList = ({
  categories,
  clickedCategory,
  expandedCategory,
  forceIsExpanded,
  primaryCategoryUrlName,
  primaryTournamentUrlName,
}) => {
  const [activeIndex] = useState(forceIsExpanded === false ? -1 : 0);
  const { getFavoriteCategories } = usePreferences();

  const sortedCategories = useMemo(
    () => getFavoriteCategories(categories, primaryCategoryUrlName),
    [categories, getFavoriteCategories, primaryCategoryUrlName],
  );

  const mainMarketsChoice = SiteConfigManager.getConfig(
    'config.config.sportsbook.mainMarketsChoice',
  );

  return (
    <>
      <h2 className="d-none">{sortedCategories[0]?.name}</h2>
      {mainMarketsChoice && <MarketTypeSelector />}
      <div className={cx('category-container', 'categories')}>
        {sortedCategories.map((category, i) => {
          const { id, totalCount } = category;

          const forceExpand = i === activeIndex;

          return (
            <ViewportDisplayController
              counter={forceExpand ? totalCount : 0}
              key={id}
              placeholder={CategoryPlaceholder}
            >
              <ExpandableCategoryTournaments
                category={category}
                clickedCategory={clickedCategory}
                expandedCategory={expandedCategory}
                forceIsExpanded={forceExpand}
                primaryTournamentUrlName={primaryTournamentUrlName}
              />
            </ViewportDisplayController>
          );
        })}
      </div>
      <SeoPageText />
    </>
  );
};

CategoriesList.propTypes = {
  categories: PropTypes.arrayOf(categoryShape).isRequired,
  clickedCategory: PropTypes.func,
  isAllExpanded: PropTypes.bool,
};

export default CategoriesList;
